import throttle from '../utils/throttle';

const ScrollDirection = {

    last_position: 0,
    direction: 'down',

    init() {
        window.addEventListener("scroll", throttle(60, () => {
            let st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > this.last_position) {
                this.direction = 'down';
            } else {
                this.direction = 'up';
            }
            this.last_position = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }), false);
    },

    is_up() {
        return this.direction === 'up';
    },

    is_down() {
        return this.direction === 'down';
    },

};

export default ScrollDirection;